import React, { useContext, useMemo } from 'react';
import { PinApi } from '../../../../../redux/api/PinApi';
import { IUserProfile } from '../../../../../types/User/IUserProfile';
import { RevUserContext, RevUserContextType } from '../../../../../context/UserContext';
import { Link, useParams } from 'react-router-dom';
import { Button } from '@progress/kendo-react-buttons';
import { ITicket } from '../../../../../types/Ticket/ITicket';
import { Sortable, SortableItemUIProps, SortableOnDragOverEvent } from '@progress/kendo-react-sortable';
import { IPinItem } from '../../../../../types/Pin/IPinItem';
import * as svg from '@progress/kendo-svg-icons';
import { SvgIcon } from '@progress/kendo-react-common';
import background from '../../../../DropdownCheckbox/styled/background';

const Dockbar: React.FC<ITicket> = (ticket) => {
    const [selected, setSelected] = React.useState(0);
    const { profile } = useContext<RevUserContextType>(RevUserContext)
    var { data } = PinApi.useGetPinsQuery(undefined, { skip: !profile?.Features?.Pin_Dock });
    //get the ticket Id from the route variable
    const { ticketId } = useParams()
    const [editMode, setEditMode] = React.useState(false);
    const [orderState, setOrderState] = React.useState<Array<IPinItem>>();
    const [reorderPins] = PinApi.useReorderPinsMutation();


    const renderItems = useMemo(() => data && [...data].sort((a, b) => {
        // Only sort on Order if not identical
        if (a.Order < b.Order) return 1;
        if (a.Order > b.Order) return -1;
        // 2nd Sort on Id
        if (a.Id < b.Id) return -1;
        if (a.Id > b.Id) return 1;
        // Both idential, return 0
        return 0;
    }
    ).map((p, i) => {
        return {
            ...p,
            //Order: i
        };
    }), [data]);


    //load the pins into state
    React.useEffect(() => {
        if (renderItems) {
            setOrderState(renderItems);
        }
    }, [renderItems]);

    if (!profile?.Features?.Pin_Dock)
        return <></>;

    const handleSelect = e => {
        setSelected(e.selected);
    };

    const onDragOver = (event: SortableOnDragOverEvent) => {
        console.warn('onDragOver', event.newState);

        setOrderState(event.newState as Array<IPinItem>);
    };

    const getBaseItemStyle = (isActive: boolean) => ({
        lineHeight: '38px',
        fontSize: '16px',
        textAlign: 'center',
        outline: 'none',
        border: '1px dashed',
        cursor: 'move',
        display: 'inline-block',
        paddingLeft: 6,
        paddingRight: 6,
        marginRight: 6,
        borderColor: '#000',
        width: 'aUTO',
        backgroundColor: '#969595',
        zIndex: 1000,
        color: '#fff',
    });

    const SortableItemUI = (props: SortableItemUIProps) => {
        const { style, attributes, dataItem, forwardRef } = props;
        //const classNames = ['col-xs-6 col-sm-3'];
        return (
            <div key={dataItem.Id}
                ref={forwardRef}
                {...attributes}
                style={{
                    ...getBaseItemStyle(true),
                    ...style
                }}
                className={ticketId == dataItem.Call_Id.toString() ? (ticket?.StateCssClass || "BlueBG") : ""}
            >
                <div className='sortable-item d-flex align-items-center' title={dataItem.Call_Id}>
                    <SvgIcon icon={svg.handleDragIcon} /> {dataItem.Call_Id}
                </div>
            </div>
        );
    };

    const onSave = (state) => {
        //Update the order and visibility of the user's options
        let neworder = [...orderState].reverse().map((p, i) => {
            return {
                ...p,
                Order: i
            };
        });

        reorderPins(neworder).then(() => {
            setEditMode(false);
        });
    }

    const onCancel = () => {
        //setData(defaultTileArray);
        setOrderState(renderItems);
        setEditMode(false);
    }

    if (!renderItems?.length) return <></>;

    //Bootstrap tabs
    return (
        <div className='d-none d-lg-block'>
            <ul className='nav-dock-bar nav nav-tabs justify-content-end flex align-items-center' >
                {editMode ? <div className='gap-1 d-flex align-items-baseline'>
                    <Button size='medium' svgIcon={svg.saveIcon} fillMode='solid' title='Save' onClick={onSave}></Button>
                    <Button size='medium' svgIcon={svg.cancelIcon} fillMode='solid' title='Cancel' onClick={onCancel}></Button>
                    {orderState && <Sortable idField={'Id'} data={orderState} itemUI={SortableItemUI} onDragOver={onDragOver}></Sortable>}
                </div>
                    : <>
                        {orderState?.length > 1 && <li className={"nav-item reorder-item d-none"} title='Reorder items'>
                            <Button size='small' className='mr-1' title='Reorder items' svgIcon={svg.replaceSingleIcon} fillMode='solid' onClick={() => setEditMode(true)}></Button>
                        </li>}
                        {orderState?.map((p, i) =>
                            <li key={p.Id} title={p.Tooltip} className={"nav-item"} > <Link className={ticketId == p.Call_Id.toString() ? "nav-link " + (ticket?.StateCssClass || "BlueBG") : "nav-link"} to={`/ticket/${p.Call_Id}/?from=Pins`}><Link to={`unpin/${p.Id}`}><Button className='pin-button' size='small' fillMode='flat' imageUrl='./images/pin-dock-white.png' /></Link>{p.Call_Id}</Link></li>
                        )}
                    </>

                }
            </ul>
        </div >
    );
};

export default Dockbar;